export default {
  heroHeadingTextTransform: 'uppercase',
};
